import reduceReducers from 'reduce-reducers';
import { crudReducer, crudInitialState } from './crud';
import { cartReducer, cartInitialState } from './cart';

export const initialState = {
  ...crudInitialState,
  ...cartInitialState,
}
export default reduceReducers(crudReducer, cartReducer, initialState);
//export default crudReducer;
